import React, { Component } from 'react';
import './PMWindowedApp.css';
import PMDesktop from './desktop/PMDesktop';
import PageWrapper from '../shared/PageWrapper';

class PMWindowApp extends Component {
  render() {
	const { match } = this.props;
	return (
	  <PageWrapper match={match}>
		<div className="PMWindowApp">
		  {this.modes()}
		</div>
	  </PageWrapper>
	);
  }

  modes = () => {
	const { match } = this.props;

	if (match.path.indexOf('/projectmanager/desktop') > -1) {
	  return <PMDesktop />
	}

  }
}

export default PMWindowApp;


// WEBPACK FOOTER //
// ./src/components/projectmanager/PMWindowApp.js